export default __webpack_public_path__ + "media/images/user_photos/62-c1f7a464168c7c7c19c323c1e75ad2cf.jpg";